import {Component, Input, OnInit} from '@angular/core';
import {NgIf} from '@angular/common';

import {EvaluationsService} from '../services/evaluations.service';

/**
 * One still from the recording.
 *
 * Storage download URLs are signed and have to be fetched per object, so the
 * component resolves its own — the alternative was every list screen doing it
 * and caching separately. Inline template: it is fifteen lines and three files
 * for it would be noise.
 */
@Component({
  selector: 'app-evidence-image',
  standalone: true,
  imports: [NgIf],
  template: `
    <figure class="shot" *ngIf="path">
      <img *ngIf="url" [src]="url" [alt]="caption" loading="lazy">
      <div class="failed" *ngIf="failed">preview unavailable</div>
      <figcaption *ngIf="caption">{{ caption }}</figcaption>
    </figure>
  `,
  styles: `
    .shot {
      margin: 0;
      width: 200px;
    }

    img {
      width: 100%;
      border-radius: 4px;
      display: block;
    }

    .failed {
      height: 112px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      background: rgba(0, 0, 0, 0.06);
      color: rgba(0, 0, 0, 0.54);
      font-size: 12px;
    }

    figcaption {
      font-size: 12px;
      color: rgba(0, 0, 0, 0.54);
      padding-top: 4px;
    }
  `,
})
export class EvidenceImageComponent implements OnInit {

  @Input() path: string | null;
  @Input() caption = '';

  url: string;
  failed = false;

  constructor(private evaluations: EvaluationsService) {
  }

  ngOnInit(): void {
    if (!this.path) {
      this.failed = true;
      return;
    }
    this.evaluations.evidenceUrl(this.path)
      .then(url => this.url = url)
      .catch(() => this.failed = true);
  }
}
